module.exports = __webpack_public_path__ + "img/sup-speed-sd.a71aa32e.png";